// extracted by mini-css-extract-plugin
export default {"Spacer":"Spacer_Spacer__001rb"};